import { Segment } from './Segment.js';
import { styled } from '@/stitches/index.js';
import { type ReactNode } from 'react';
import { v4 as uuidv4 } from 'uuid';

const Wrapper = styled('div', {
  display: 'inline-block',
});

export const SegmentClones = ({
  children,
  itemSpacingValue,
  segmentCloneCount,
}: {
  readonly children: ReactNode;
  readonly itemSpacingValue?: number | string;
  readonly segmentCloneCount: number;
}) => {
  return (
    <Wrapper>
      {Array.from({ length: segmentCloneCount }).map(() => (
        <Segment
          itemSpacingValue={itemSpacingValue}
          key={uuidv4()}
        >
          {children}
        </Segment>
      ))}
    </Wrapper>
  );
};
